const RECAPTCHA_REGEX = /^([A-z]|_|\/)+$/;

export default RECAPTCHA_REGEX;
